import script from "./DistributeRecordsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributeRecordsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DistributeRecordsDrawer.vue?vue&type=style&index=0&id=b08a526c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b08a526c"]])

export default __exports__